import React, { useContext } from "react";
import { GlobalContext } from "../header/GlobalContext";

const PayoutChart = ({ props }) => {
  const { multiplier, protectedMulipliers, multiplierType } = useContext(GlobalContext);
  const easySelected = props.selected.find((x) => x.easy);
  const hardSelected = props.selected.find((x) => x.hard);
  const protectedActive = multiplierType === "protected" && protectedMulipliers !== undefined;


  return (
    <>
      <div className={"payout-info mt-4" + (props.selected.length == 2 ? " selected" : "")}>
        2 Picks = 3X 💰
      </div>

      <div className={"payout-info mt-2" + (props.selected.length == 3 ? " selected" : "")}>
        3 Picks = { multiplierType === "protected" ? "2X or 1" : "5" }X 💸
      </div>

      <div className={"payout-info mt-2" + (props.selected.length == 4 ? " selected" : "")}>
        4 Picks = { multiplierType === "protected" ? "5X or 1.5" : "10" }X 😲
      </div>

      <div className={"payout-info mt-2" + (props.selected.length == 5 ? " selected" : "")}>
        5 Picks = { multiplierType === "protected" ? "6X, 2X or 0.4" : "15" }X 🤯
      </div>

      <div className={"payout-info mt-2" + (props.selected.length == 6 ? " selected" : "")}>
        6 Picks = { multiplierType === "protected" ? "8X, 2X or 0.4" : "20" }X 🤑
      </div>
    </>
  );
};

export default PayoutChart;